<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VQaPOS/tc-custom/9781504077163.jpg?1702178634939" alt="This image is the cover for the book H.M.S. Hood vs. Bismarck"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">H.M.S. Hood vs. Bismarck
      </h1>
      <p class="bookDescription body article font2">
        <b>An account of the WWII sea battle by the author of <i>The Cay</i>: “The story of the Bismarck is one of exciting high adventure, and [Taylor] captures it nicely.” —<i>The New York Times</i></b><br/><br/> From the award-winning author, this is a compelling history of the sinking of British battlecruiser H.M.S. <i>Hood</i> in the cold waters of the North Atlantic in 1941. It was a great loss to the Royal Navy and resulted in the deaths of more than fourteen hundred sailors. Soon the Allies were in hot pursuit of the <i>Bismarck</i>, the German fleet’s biggest and most fearsome ship.<br/><br/> The Nazi battleship would meet its end just days after it sank the <i>Hood</i>—and this book tells the riveting story of this deadly confrontation at sea.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theodore Taylor
      </h2>
      
      <p class="authorDescription body article">Theodore Taylor was an American author of more than fifty fiction and nonfiction books for young adult and adult readers. During World War II, he first served as a cadet-AB seaman on a gasoline tanker, then became a naval officer in the Pacific Theater. Taylor published his first book, <I>The Magnificent Mitscher</I>, in 1955. His novel <I>The Cay </I>won eleven literary awards, including the Lewis Carroll Shelf Award, and was adapted into a film in 1974. In 2006, Taylor passed away in his beloved &ldquo;house in the woods&rdquo; in Laguna Beach, California. He was surrounded by his family, his books, and years of wonderful memories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?346445ce